import { render, staticRenderFns } from "./RequestReturnEditingUser.vue?vue&type=template&id=13b6fc1e"
import script from "./RequestReturnEditingUser.vue?vue&type=script&lang=js"
export * from "./RequestReturnEditingUser.vue?vue&type=script&lang=js"
import style0 from "./RequestReturnEditingUser.vue?vue&type=style&index=0&id=13b6fc1e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports